import { createTheme, responsiveFontSizes, type Theme } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import { typography } from './typography';
import { getComponentOverrides } from './components';

/**
 * Create a fully-configured BeMoTechs MUI theme for the given colour mode.
 *
 * The returned theme includes:
 * - Brand palette (light or dark)
 * - Typography scale with Inter font family
 * - Component style overrides
 * - Responsive font sizes
 */
export function createAppTheme(mode: 'light' | 'dark'): Theme {
  const palette = mode === 'light' ? lightPalette : darkPalette;

  let theme = createTheme({
    palette,
    typography,
    shape: {
      borderRadius: 8,
    },
    components: getComponentOverrides(mode),
  });

  theme = responsiveFontSizes(theme);

  return theme;
}
